"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6082],{

/***/ 6082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rating": function() { return /* reexport */ Rating; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var constants = __webpack_require__(71467);
;// CONCATENATED MODULE: ./src/components/atoms/Rating/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n\n  width: 32px;\n  height: 32px;\n  svg {\n    margin: 0 auto;\n    horizontal-align: middle;\n    stroke: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledRating = emotion_styled_browser_esm/* default.span */.Z.span(_templateObject1(), constants/* theme.black */.rS.black, globalStyles/* minMedia.mediumScreen */.td.mediumScreen(_templateObject()));

;// CONCATENATED MODULE: ./src/components/atoms/Rating/Rating.tsx





var Rating = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var size = param.size, rate = param.rate, fillColor = param.fillColor, showText = param.showText;
    var buttons = [
        0,
        0,
        0,
        0,
        0
    ];
    if (rate && rate > 0) {
        // consider rating 0 to 4 as per array index
        var rating = Math.floor(rate) - 1;
        var fractionalPart = Number((rate - (rating + 1)).toFixed(1));
        // Push the integer part of the rating (full stars)
        for(var i = 0; i <= rating; i++){
            buttons[i] = 1;
        }
        // Push the partially filled star if there's a fractional part
        if (fractionalPart > 0) {
            buttons[rating + 1] = fractionalPart;
        }
    }
    var hideRating = rate <= 0;
    var ratingCeiling = Math.ceil(rate * 10) / 10;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                display: "flex",
                flexDirection: "row",
                children: !hideRating && buttons.map(function(item, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRating, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Icon, {
                            name: "star_full",
                            size: size,
                            color: fillColor,
                            fillOpacity: item,
                            translateX: 7,
                            fractionalPart: item ? item % 1 : 0
                        })
                    }, index);
                })
            }),
            showText ? hideRating ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    children: "No Customer Reviews received yet"
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                    children: [
                        ratingCeiling,
                        " Stars"
                    ]
                })
            }) : null
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/atoms/Rating/index.ts



/***/ })

}]);